export default {
  headerContent: {
    title: 'Türk Nippon Sigorta Doğum (Hamilelik) Sağlık Sigortası Teklifi Hesaplama',
    slogan: "Doğum Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DOĞUM SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Hamilelik ve Doğum Sigortası Nedir?',
    description: {
      title: 'Türk Nippon Hamilelik ve Doğum Sigortası Nedir? ',
      content: [
        'Annelik duygusu bir annenin tadabileceği en güzel duygudur. Bu duygu ne kadar güzel olsa da mide bulantıları, kusmalar, bel - sırt ağrıları ve baş dönmesi gibi birçok sıkıntıyla gelir.',
        'Bu sıkıntıları yaşarken hamilelik döneminde oluşacak rahatsızlıkların masraflarını düşünmemek için doğum sigortası alabilirsiniz.',
        'Doğum sigortası, ailenize yeni katılacak bebeğin doğum öncesi ve doğum sırasında oluşacak hastane masraflarını poliçede belirtilmiş limitler dâhilinde karşılar.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Doğum Paketi Teminatları (Kapsamı) Nelerdir?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta’nın sunmuş olduğu “Hayata Merhaba Sigortası” kapsamında Acil sağlık + doğum eylemi planı ve Acil sağlık + doğum eylemi + tetkik paneli planı olmak üzere 2 adet farklı teminat paketi bulunmaktadır.',
          subList: ['<strong>Acil Sağlık + Doğum Eylemi Planı</strong>']
        },
        {
          paragraph:
            'Normal doğum ve sezaryen doğumu karşılamakla birlikte acil durum sebebiyle sigortalıya uygulanacak cerrahi müdahaleler, ameliyatlar, ilaç ve sarf malzeme masrafları karşılanmaktadır.',
          subList: [
            '<strong>Acil Sağlık + Doğum Eylemi + Tetkik Paneli Planı</strong>'
          ]
        },
        {
          paragraph: 'Acil sağlık ve doğum eylemi planına ek olarak kan sayımı, klor, sodyum ve down sendromu gibi tetkikleri karşılamaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Doğum Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Doğum Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Doğum Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Doğum Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Doğum Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türk Nippon Sigorta Doğum Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
